// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* API Documentation - Clean Modern Theme */
.api-documentation {
  min-height: 100vh;
  background: var(--dashboard-bg-primary);
  color: var(--dashboard-text-primary);
}

/* Header */
.doc-header {
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  color: white;
  padding: var(--dashboard-space-10) var(--dashboard-space-6);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.doc-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%);
  backdrop-filter: blur(10px);
}

.doc-header h1 {
  margin: 0 0 var(--dashboard-space-3) 0;
  font-size: 2.5rem;
  font-weight: 700;
  position: relative;
  z-index: 2;
}

.doc-header p {
  margin: 0;
  font-size: 1.125rem;
  opacity: 0.95;
  position: relative;
  z-index: 2;
}

/* Container */
.doc-container {
  display: flex;
  max-width: 1400px;
  margin: 0 auto;
  min-height: calc(100vh - 160px);
  gap: var(--dashboard-space-6);
  padding: var(--dashboard-space-6);
}

/* Sidebar Navigation */
.doc-sidebar {
  width: 300px;
  background: var(--dashboard-card-bg);
  border-radius: var(--dashboard-radius-xl);
  box-shadow: var(--dashboard-shadow-sm);
  border: 1px solid var(--dashboard-border);
  backdrop-filter: blur(20px);
  position: sticky;
  top: var(--dashboard-space-6);
  height: fit-content;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.doc-nav {
  padding: var(--dashboard-space-6);
}

.nav-item {
  display: flex;
  align-items: center;
  gap: var(--dashboard-space-3);
  width: 100%;
  padding: var(--dashboard-space-4);
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  color: var(--dashboard-text-secondary);
  border-radius: var(--dashboard-radius-lg);
  margin-bottom: var(--dashboard-space-2);
  font-weight: 500;
}

.nav-item:hover {
  background: var(--dashboard-bg-hover);
  color: var(--dashboard-text-primary);
  transform: translateX(4px);
}

.nav-item.active {
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  color: white;
  font-weight: 600;
  box-shadow: var(--dashboard-shadow-md);
}

.nav-icon {
  font-size: 1.125rem;
  min-width: 24px;
}

.nav-title {
  font-weight: inherit;
}

/* Content Area */
.doc-content {
  flex: 1 1;
  background: var(--dashboard-card-bg);
  border-radius: var(--dashboard-radius-xl);
  box-shadow: var(--dashboard-shadow-sm);
  border: 1px solid var(--dashboard-border);
  backdrop-filter: blur(20px);
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

/* Scrollbar Styling */
.doc-content::-webkit-scrollbar,
.doc-sidebar::-webkit-scrollbar {
  width: 6px;
}

.doc-content::-webkit-scrollbar-track,
.doc-sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.doc-content::-webkit-scrollbar-thumb,
.doc-sidebar::-webkit-scrollbar-thumb {
  background: var(--dashboard-border);
  border-radius: 3px;
}

.doc-content::-webkit-scrollbar-thumb:hover,
.doc-sidebar::-webkit-scrollbar-thumb:hover {
  background: var(--dashboard-text-secondary);
}

.doc-section {
  padding: var(--dashboard-space-8);
}

.doc-section h2 {
  margin: 0 0 var(--dashboard-space-4) 0;
  color: var(--dashboard-text-primary);
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--dashboard-text-primary) 0%, var(--dashboard-primary) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-description {
  margin: 0 0 var(--dashboard-space-8) 0;
  font-size: 1rem;
  color: var(--dashboard-text-secondary);
  line-height: 1.6;
}

/* Features Grid */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--dashboard-space-6);
  margin: var(--dashboard-space-8) 0;
}

.feature-card {
  padding: var(--dashboard-space-6);
  background: var(--dashboard-bg-secondary);
  border: 1px solid var(--dashboard-border);
  border-radius: var(--dashboard-radius-lg);
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.feature-card:hover::before {
  opacity: 0.05;
}

.feature-card:hover {
  border-color: var(--dashboard-primary);
  transform: translateY(-4px);
  box-shadow: var(--dashboard-shadow-lg);
}

.feature-icon {
  font-size: 2rem;
  margin-bottom: var(--dashboard-space-4);
  position: relative;
  z-index: 2;
}

.feature-card h3 {
  margin: 0 0 var(--dashboard-space-2) 0;
  color: var(--dashboard-text-primary);
  font-size: 1.125rem;
  font-weight: 600;
  position: relative;
  z-index: 2;
}

.feature-card p {
  margin: 0;
  color: var(--dashboard-text-secondary);
  font-size: 0.875rem;
  line-height: 1.5;
  position: relative;
  z-index: 2;
}

/* Getting Started */
.getting-started {
  background: var(--dashboard-bg-secondary);
  padding: var(--dashboard-space-6);
  border-radius: var(--dashboard-radius-lg);
  margin: var(--dashboard-space-8) 0;
  border: 1px solid var(--dashboard-border);
}

.getting-started h3 {
  margin: 0 0 var(--dashboard-space-4) 0;
  color: var(--dashboard-text-primary);
  font-size: 1.25rem;
  font-weight: 600;
}

.getting-started ol {
  margin: 0;
  padding-left: var(--dashboard-space-5);
  color: var(--dashboard-text-secondary);
  line-height: 1.6;
}

.getting-started li {
  margin-bottom: var(--dashboard-space-2);
}

.getting-started code {
  background: var(--dashboard-primary);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
}

/* Auth Methods */
.auth-methods {
  display: flex;
  flex-direction: column;
  gap: var(--dashboard-space-6);
  margin: var(--dashboard-space-8) 0;
}

.auth-method {
  background: var(--dashboard-bg-secondary);
  padding: var(--dashboard-space-6);
  border-radius: var(--dashboard-radius-lg);
  border: 1px solid var(--dashboard-border);
}

.auth-method h3 {
  margin: 0 0 var(--dashboard-space-3) 0;
  color: var(--dashboard-text-primary);
  font-size: 1.125rem;
  font-weight: 600;
}

.auth-method p {
  margin: 0 0 var(--dashboard-space-4) 0;
  color: var(--dashboard-text-secondary);
  line-height: 1.5;
}

/* Code Blocks */
.code-block {
  background: #1a1a1a;
  color: #e2e8f0;
  padding: var(--dashboard-space-4);
  border-radius: var(--dashboard-radius-md);
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.875rem;
  line-height: 1.6;
  overflow-x: auto;
  margin: var(--dashboard-space-4) 0;
  border: 1px solid var(--dashboard-border);
}

.code-block::-webkit-scrollbar {
  height: 6px;
}

.code-block::-webkit-scrollbar-track {
  background: transparent;
}

.code-block::-webkit-scrollbar-thumb {
  background: #4a5568;
  border-radius: 3px;
}

/* Role Permissions */
.role-permissions {
  margin: var(--dashboard-space-8) 0;
}

.role-permissions h3 {
  margin: 0 0 var(--dashboard-space-6) 0;
  color: var(--dashboard-text-primary);
  font-size: 1.25rem;
  font-weight: 600;
}

.role-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--dashboard-space-4);
}

.role-card {
  background: var(--dashboard-bg-secondary);
  padding: var(--dashboard-space-5);
  border-radius: var(--dashboard-radius-lg);
  border: 1px solid var(--dashboard-border);
}

.role-card h4 {
  margin: 0 0 var(--dashboard-space-3) 0;
  color: var(--dashboard-text-primary);
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: var(--dashboard-space-2);
}

.role-card ul {
  margin: 0;
  padding-left: var(--dashboard-space-4);
  color: var(--dashboard-text-secondary);
  font-size: 0.875rem;
}

.role-card li {
  margin-bottom: var(--dashboard-space-1);
  line-height: 1.5;
}

/* Endpoints */
.endpoints-container {
  display: flex;
  flex-direction: column;
  gap: var(--dashboard-space-8);
}

.endpoint-category {
  background: var(--dashboard-bg-secondary);
  border-radius: var(--dashboard-radius-lg);
  border: 1px solid var(--dashboard-border);
  overflow: hidden;
}

.category-title {
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  color: white;
  margin: 0;
  padding: var(--dashboard-space-4) var(--dashboard-space-6);
  font-size: 1.125rem;
  font-weight: 600;
}

.endpoints-list {
  padding: var(--dashboard-space-4);
}

.endpoint-item {
  margin-bottom: var(--dashboard-space-3);
  border: 1px solid var(--dashboard-border);
  border-radius: var(--dashboard-radius-md);
  overflow: hidden;
  transition: all 0.2s ease;
  background: var(--dashboard-card-bg);
}

.endpoint-item:hover {
  box-shadow: var(--dashboard-shadow-md);
  border-color: var(--dashboard-primary);
}

.endpoint-item.active {
  border-color: var(--dashboard-primary);
  box-shadow: var(--dashboard-shadow-lg);
}

.endpoint-header {
  display: flex;
  align-items: center;
  gap: var(--dashboard-space-4);
  padding: var(--dashboard-space-4);
  cursor: pointer;
  background: var(--dashboard-bg-primary);
}

.method {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  min-width: 60px;
  text-align: center;
}

.method.get {
  background: #dcfce7;
  color: #16a34a;
}

.method.post {
  background: #dbeafe;
  color: #2563eb;
}

.method.put {
  background: #fef3c7;
  color: #d97706;
}

.method.delete {
  background: #fee2e2;
  color: #dc2626;
}

.path {
  font-family: 'Monaco', 'Menlo', monospace;
  font-size: 0.875rem;
  color: var(--dashboard-text-secondary);
  background: var(--dashboard-bg-secondary);
  padding: 4px 8px;
  border-radius: 4px;
  flex: 1 1;
}

.title {
  font-weight: 600;
  color: var(--dashboard-text-primary);
}

/* Endpoint Details */
.endpoint-details {
  padding: var(--dashboard-space-6);
  border-top: 1px solid var(--dashboard-border);
  background: var(--dashboard-card-bg);
}

.description {
  margin: 0 0 var(--dashboard-space-6) 0;
  color: var(--dashboard-text-secondary);
  line-height: 1.6;
}

.headers-section,
.parameters-section,
.response-section,
.example-section {
  margin-bottom: var(--dashboard-space-6);
}

.headers-section h4,
.parameters-section h4,
.response-section h4,
.example-section h4 {
  margin: 0 0 var(--dashboard-space-4) 0;
  color: var(--dashboard-text-primary);
  font-size: 1rem;
  font-weight: 600;
}

.parameter {
  background: var(--dashboard-bg-secondary);
  padding: var(--dashboard-space-3);
  border-radius: var(--dashboard-radius-md);
  margin-bottom: var(--dashboard-space-3);
  border: 1px solid var(--dashboard-border);
}

.parameter strong {
  color: var(--dashboard-text-primary);
  font-weight: 600;
}

.parameter .type {
  color: var(--dashboard-text-secondary);
  font-size: 0.875rem;
  margin-left: var(--dashboard-space-2);
}

.parameter .required {
  background: #fee2e2;
  color: #dc2626;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-left: var(--dashboard-space-2);
}

.parameter p {
  margin: var(--dashboard-space-2) 0 0 0;
  color: var(--dashboard-text-secondary);
  font-size: 0.875rem;
  line-height: 1.5;
}

/* Webhook Styles */
.webhook-features {
  margin: var(--dashboard-space-8) 0;
}

.webhook-features h3 {
  margin: 0 0 var(--dashboard-space-4) 0;
  color: var(--dashboard-text-primary);
  font-size: 1.25rem;
  font-weight: 600;
}

.webhook-features ul {
  margin: 0;
  padding-left: var(--dashboard-space-5);
  color: var(--dashboard-text-secondary);
}

.webhook-features li {
  margin-bottom: var(--dashboard-space-2);
  line-height: 1.5;
}

.webhook-setup {
  margin: var(--dashboard-space-8) 0;
}

.webhook-setup h3 {
  margin: 0 0 var(--dashboard-space-6) 0;
  color: var(--dashboard-text-primary);
  font-size: 1.25rem;
  font-weight: 600;
}

.setup-step {
  display: flex;
  gap: var(--dashboard-space-4);
  margin-bottom: var(--dashboard-space-6);
  padding: var(--dashboard-space-6);
  background: var(--dashboard-bg-secondary);
  border-radius: var(--dashboard-radius-lg);
  border: 1px solid var(--dashboard-border);
}

.step-number {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  flex-shrink: 0;
}

.step-content {
  flex: 1 1;
}

.step-content h4 {
  margin: 0 0 var(--dashboard-space-2) 0;
  color: var(--dashboard-text-primary);
  font-size: 1rem;
  font-weight: 600;
}

.step-content p {
  margin: 0 0 var(--dashboard-space-4) 0;
  color: var(--dashboard-text-secondary);
  line-height: 1.5;
}

/* Events */
.webhook-events {
  margin: var(--dashboard-space-8) 0;
}

.webhook-events h3 {
  margin: 0 0 var(--dashboard-space-6) 0;
  color: var(--dashboard-text-primary);
  font-size: 1.25rem;
  font-weight: 600;
}

.event-item {
  background: var(--dashboard-bg-secondary);
  padding: var(--dashboard-space-6);
  border-radius: var(--dashboard-radius-lg);
  border: 1px solid var(--dashboard-border);
  margin-bottom: var(--dashboard-space-4);
}

.event-item h4 {
  margin: 0 0 var(--dashboard-space-2) 0;
  color: var(--dashboard-text-primary);
  font-size: 1rem;
  font-weight: 600;
}

.event-item p {
  margin: 0 0 var(--dashboard-space-4) 0;
  color: var(--dashboard-text-secondary);
  line-height: 1.5;
}

/* Auto Reply */
.auto-reply-section {
  margin: var(--dashboard-space-8) 0;
  background: var(--dashboard-bg-secondary);
  padding: var(--dashboard-space-6);
  border-radius: var(--dashboard-radius-lg);
  border: 1px solid var(--dashboard-border);
}

.auto-reply-section h3 {
  margin: 0 0 var(--dashboard-space-4) 0;
  color: var(--dashboard-text-primary);
  font-size: 1.25rem;
  font-weight: 600;
}

.auto-reply-section p {
  margin: 0 0 var(--dashboard-space-4) 0;
  color: var(--dashboard-text-secondary);
  line-height: 1.5;
}

/* Examples */
.examples-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: var(--dashboard-space-6);
  margin: var(--dashboard-space-8) 0;
}

.example-card {
  background: var(--dashboard-bg-secondary);
  border-radius: var(--dashboard-radius-lg);
  border: 1px solid var(--dashboard-border);
  overflow: hidden;
}

.example-card h3 {
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  color: white;
  margin: 0;
  padding: var(--dashboard-space-4) var(--dashboard-space-6);
  font-size: 1rem;
  font-weight: 600;
}

.example-card .code-block {
  margin: 0;
  border-radius: 0;
  border: none;
}

/* Error Codes */
.error-codes {
  display: flex;
  flex-direction: column;
  gap: var(--dashboard-space-6);
}

.error-category {
  background: var(--dashboard-bg-secondary);
  border-radius: var(--dashboard-radius-lg);
  border: 1px solid var(--dashboard-border);
  overflow: hidden;
}

.error-category h3 {
  background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
  color: white;
  margin: 0;
  padding: var(--dashboard-space-4) var(--dashboard-space-6);
  font-size: 1.125rem;
  font-weight: 600;
}

.error-list {
  padding: var(--dashboard-space-4);
}

.error-item {
  display: flex;
  gap: var(--dashboard-space-4);
  padding: var(--dashboard-space-4);
  background: var(--dashboard-card-bg);
  border-radius: var(--dashboard-radius-md);
  border: 1px solid var(--dashboard-border);
  margin-bottom: var(--dashboard-space-3);
}

.error-code {
  background: #fee2e2;
  color: #dc2626;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 0.875rem;
  min-width: 50px;
  text-align: center;
}

.error-details strong {
  color: var(--dashboard-text-primary);
  font-weight: 600;
  display: block;
  margin-bottom: var(--dashboard-space-1);
}

.error-details p {
  margin: 0;
  color: var(--dashboard-text-secondary);
  font-size: 0.875rem;
  line-height: 1.5;
}

.error-handling {
  margin: var(--dashboard-space-8) 0;
  background: var(--dashboard-bg-secondary);
  padding: var(--dashboard-space-6);
  border-radius: var(--dashboard-radius-lg);
  border: 1px solid var(--dashboard-border);
}

.error-handling h3 {
  margin: 0 0 var(--dashboard-space-4) 0;
  color: var(--dashboard-text-primary);
  font-size: 1.25rem;
  font-weight: 600;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .doc-container {
    flex-direction: column;
    padding: var(--dashboard-space-4);
    gap: var(--dashboard-space-4);
  }
  
  .doc-sidebar {
    width: 100%;
    position: static;
    max-height: none;
  }
  
  .doc-content {
    max-height: 70vh;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
  }
  
  .examples-grid {
    grid-template-columns: 1fr;
  }
  
  .role-grid {
    grid-template-columns: 1fr;
  }
  
  .endpoint-header {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--dashboard-space-2);
  }
  
  .setup-step {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .error-item {
    flex-direction: column;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/APIDocumentation.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,iBAAiB;EACjB,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA,WAAW;AACX;EACE,iGAAiG;EACjG,YAAY;EACZ,2DAA2D;EAC3D,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yFAAyF;EACzF,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,oCAAoC;EACpC,yCAAyC;EACzC,sCAAsC;EACtC,yCAAyC;EACzC,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;EACtC,yCAAyC;EACzC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,iGAAiG;EACjG,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,oCAAoC;EACpC,yCAAyC;EACzC,sCAAsC;EACtC,yCAAyC;EACzC,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;;EAEE,UAAU;AACZ;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,oGAAoG;EACpG,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iGAAiG;EACjG,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,yCAAyC;EACzC,iCAAiC;EACjC,yCAAyC;EACzC,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,yCAAyC;EACzC,wDAAwD;EACxD,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,iGAAiG;EACjG,YAAY;EACZ,SAAS;EACT,0DAA0D;EAC1D,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,yCAAyC;EACzC,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,iCAAiC;EACjC,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,sCAAsC;EACtC,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,iCAAiC;EACjC,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;;;;EAIE,uCAAuC;AACzC;;AAEA;;;;EAIE,sCAAsC;EACtC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,yCAAyC;EACzC,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,uCAAuC;EACvC,iCAAiC;EACjC,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iGAAiG;EACjG,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,yCAAyC;EACzC,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kCAAkC;EAClC,yCAAyC;EACzC,iCAAiC;EACjC,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,2DAA2D;EAC3D,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,iGAAiG;EACjG,YAAY;EACZ,SAAS;EACT,0DAA0D;EAC1D,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,SAAS;EACT,0DAA0D;EAC1D,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iCAAiC;EACjC,oCAAoC;EACpC,yCAAyC;EACzC,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,iCAAiC;EACjC,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,iCAAiC;IACjC,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":["/* API Documentation - Clean Modern Theme */\n.api-documentation {\n  min-height: 100vh;\n  background: var(--dashboard-bg-primary);\n  color: var(--dashboard-text-primary);\n}\n\n/* Header */\n.doc-header {\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  color: white;\n  padding: var(--dashboard-space-10) var(--dashboard-space-6);\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.doc-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%);\n  backdrop-filter: blur(10px);\n}\n\n.doc-header h1 {\n  margin: 0 0 var(--dashboard-space-3) 0;\n  font-size: 2.5rem;\n  font-weight: 700;\n  position: relative;\n  z-index: 2;\n}\n\n.doc-header p {\n  margin: 0;\n  font-size: 1.125rem;\n  opacity: 0.95;\n  position: relative;\n  z-index: 2;\n}\n\n/* Container */\n.doc-container {\n  display: flex;\n  max-width: 1400px;\n  margin: 0 auto;\n  min-height: calc(100vh - 160px);\n  gap: var(--dashboard-space-6);\n  padding: var(--dashboard-space-6);\n}\n\n/* Sidebar Navigation */\n.doc-sidebar {\n  width: 300px;\n  background: var(--dashboard-card-bg);\n  border-radius: var(--dashboard-radius-xl);\n  box-shadow: var(--dashboard-shadow-sm);\n  border: 1px solid var(--dashboard-border);\n  backdrop-filter: blur(20px);\n  position: sticky;\n  top: var(--dashboard-space-6);\n  height: fit-content;\n  max-height: calc(100vh - 200px);\n  overflow-y: auto;\n}\n\n.doc-nav {\n  padding: var(--dashboard-space-6);\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: var(--dashboard-space-3);\n  width: 100%;\n  padding: var(--dashboard-space-4);\n  border: none;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.875rem;\n  color: var(--dashboard-text-secondary);\n  border-radius: var(--dashboard-radius-lg);\n  margin-bottom: var(--dashboard-space-2);\n  font-weight: 500;\n}\n\n.nav-item:hover {\n  background: var(--dashboard-bg-hover);\n  color: var(--dashboard-text-primary);\n  transform: translateX(4px);\n}\n\n.nav-item.active {\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  color: white;\n  font-weight: 600;\n  box-shadow: var(--dashboard-shadow-md);\n}\n\n.nav-icon {\n  font-size: 1.125rem;\n  min-width: 24px;\n}\n\n.nav-title {\n  font-weight: inherit;\n}\n\n/* Content Area */\n.doc-content {\n  flex: 1;\n  background: var(--dashboard-card-bg);\n  border-radius: var(--dashboard-radius-xl);\n  box-shadow: var(--dashboard-shadow-sm);\n  border: 1px solid var(--dashboard-border);\n  backdrop-filter: blur(20px);\n  max-height: calc(100vh - 200px);\n  overflow-y: auto;\n}\n\n/* Scrollbar Styling */\n.doc-content::-webkit-scrollbar,\n.doc-sidebar::-webkit-scrollbar {\n  width: 6px;\n}\n\n.doc-content::-webkit-scrollbar-track,\n.doc-sidebar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.doc-content::-webkit-scrollbar-thumb,\n.doc-sidebar::-webkit-scrollbar-thumb {\n  background: var(--dashboard-border);\n  border-radius: 3px;\n}\n\n.doc-content::-webkit-scrollbar-thumb:hover,\n.doc-sidebar::-webkit-scrollbar-thumb:hover {\n  background: var(--dashboard-text-secondary);\n}\n\n.doc-section {\n  padding: var(--dashboard-space-8);\n}\n\n.doc-section h2 {\n  margin: 0 0 var(--dashboard-space-4) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 2rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--dashboard-text-primary) 0%, var(--dashboard-primary) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.section-description {\n  margin: 0 0 var(--dashboard-space-8) 0;\n  font-size: 1rem;\n  color: var(--dashboard-text-secondary);\n  line-height: 1.6;\n}\n\n/* Features Grid */\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: var(--dashboard-space-6);\n  margin: var(--dashboard-space-8) 0;\n}\n\n.feature-card {\n  padding: var(--dashboard-space-6);\n  background: var(--dashboard-bg-secondary);\n  border: 1px solid var(--dashboard-border);\n  border-radius: var(--dashboard-radius-lg);\n  text-align: center;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.feature-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.feature-card:hover::before {\n  opacity: 0.05;\n}\n\n.feature-card:hover {\n  border-color: var(--dashboard-primary);\n  transform: translateY(-4px);\n  box-shadow: var(--dashboard-shadow-lg);\n}\n\n.feature-icon {\n  font-size: 2rem;\n  margin-bottom: var(--dashboard-space-4);\n  position: relative;\n  z-index: 2;\n}\n\n.feature-card h3 {\n  margin: 0 0 var(--dashboard-space-2) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1.125rem;\n  font-weight: 600;\n  position: relative;\n  z-index: 2;\n}\n\n.feature-card p {\n  margin: 0;\n  color: var(--dashboard-text-secondary);\n  font-size: 0.875rem;\n  line-height: 1.5;\n  position: relative;\n  z-index: 2;\n}\n\n/* Getting Started */\n.getting-started {\n  background: var(--dashboard-bg-secondary);\n  padding: var(--dashboard-space-6);\n  border-radius: var(--dashboard-radius-lg);\n  margin: var(--dashboard-space-8) 0;\n  border: 1px solid var(--dashboard-border);\n}\n\n.getting-started h3 {\n  margin: 0 0 var(--dashboard-space-4) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.getting-started ol {\n  margin: 0;\n  padding-left: var(--dashboard-space-5);\n  color: var(--dashboard-text-secondary);\n  line-height: 1.6;\n}\n\n.getting-started li {\n  margin-bottom: var(--dashboard-space-2);\n}\n\n.getting-started code {\n  background: var(--dashboard-primary);\n  color: white;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n/* Auth Methods */\n.auth-methods {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dashboard-space-6);\n  margin: var(--dashboard-space-8) 0;\n}\n\n.auth-method {\n  background: var(--dashboard-bg-secondary);\n  padding: var(--dashboard-space-6);\n  border-radius: var(--dashboard-radius-lg);\n  border: 1px solid var(--dashboard-border);\n}\n\n.auth-method h3 {\n  margin: 0 0 var(--dashboard-space-3) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1.125rem;\n  font-weight: 600;\n}\n\n.auth-method p {\n  margin: 0 0 var(--dashboard-space-4) 0;\n  color: var(--dashboard-text-secondary);\n  line-height: 1.5;\n}\n\n/* Code Blocks */\n.code-block {\n  background: #1a1a1a;\n  color: #e2e8f0;\n  padding: var(--dashboard-space-4);\n  border-radius: var(--dashboard-radius-md);\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 0.875rem;\n  line-height: 1.6;\n  overflow-x: auto;\n  margin: var(--dashboard-space-4) 0;\n  border: 1px solid var(--dashboard-border);\n}\n\n.code-block::-webkit-scrollbar {\n  height: 6px;\n}\n\n.code-block::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.code-block::-webkit-scrollbar-thumb {\n  background: #4a5568;\n  border-radius: 3px;\n}\n\n/* Role Permissions */\n.role-permissions {\n  margin: var(--dashboard-space-8) 0;\n}\n\n.role-permissions h3 {\n  margin: 0 0 var(--dashboard-space-6) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.role-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: var(--dashboard-space-4);\n}\n\n.role-card {\n  background: var(--dashboard-bg-secondary);\n  padding: var(--dashboard-space-5);\n  border-radius: var(--dashboard-radius-lg);\n  border: 1px solid var(--dashboard-border);\n}\n\n.role-card h4 {\n  margin: 0 0 var(--dashboard-space-3) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: var(--dashboard-space-2);\n}\n\n.role-card ul {\n  margin: 0;\n  padding-left: var(--dashboard-space-4);\n  color: var(--dashboard-text-secondary);\n  font-size: 0.875rem;\n}\n\n.role-card li {\n  margin-bottom: var(--dashboard-space-1);\n  line-height: 1.5;\n}\n\n/* Endpoints */\n.endpoints-container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dashboard-space-8);\n}\n\n.endpoint-category {\n  background: var(--dashboard-bg-secondary);\n  border-radius: var(--dashboard-radius-lg);\n  border: 1px solid var(--dashboard-border);\n  overflow: hidden;\n}\n\n.category-title {\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  color: white;\n  margin: 0;\n  padding: var(--dashboard-space-4) var(--dashboard-space-6);\n  font-size: 1.125rem;\n  font-weight: 600;\n}\n\n.endpoints-list {\n  padding: var(--dashboard-space-4);\n}\n\n.endpoint-item {\n  margin-bottom: var(--dashboard-space-3);\n  border: 1px solid var(--dashboard-border);\n  border-radius: var(--dashboard-radius-md);\n  overflow: hidden;\n  transition: all 0.2s ease;\n  background: var(--dashboard-card-bg);\n}\n\n.endpoint-item:hover {\n  box-shadow: var(--dashboard-shadow-md);\n  border-color: var(--dashboard-primary);\n}\n\n.endpoint-item.active {\n  border-color: var(--dashboard-primary);\n  box-shadow: var(--dashboard-shadow-lg);\n}\n\n.endpoint-header {\n  display: flex;\n  align-items: center;\n  gap: var(--dashboard-space-4);\n  padding: var(--dashboard-space-4);\n  cursor: pointer;\n  background: var(--dashboard-bg-primary);\n}\n\n.method {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  min-width: 60px;\n  text-align: center;\n}\n\n.method.get {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.method.post {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.method.put {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.method.delete {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.path {\n  font-family: 'Monaco', 'Menlo', monospace;\n  font-size: 0.875rem;\n  color: var(--dashboard-text-secondary);\n  background: var(--dashboard-bg-secondary);\n  padding: 4px 8px;\n  border-radius: 4px;\n  flex: 1;\n}\n\n.title {\n  font-weight: 600;\n  color: var(--dashboard-text-primary);\n}\n\n/* Endpoint Details */\n.endpoint-details {\n  padding: var(--dashboard-space-6);\n  border-top: 1px solid var(--dashboard-border);\n  background: var(--dashboard-card-bg);\n}\n\n.description {\n  margin: 0 0 var(--dashboard-space-6) 0;\n  color: var(--dashboard-text-secondary);\n  line-height: 1.6;\n}\n\n.headers-section,\n.parameters-section,\n.response-section,\n.example-section {\n  margin-bottom: var(--dashboard-space-6);\n}\n\n.headers-section h4,\n.parameters-section h4,\n.response-section h4,\n.example-section h4 {\n  margin: 0 0 var(--dashboard-space-4) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.parameter {\n  background: var(--dashboard-bg-secondary);\n  padding: var(--dashboard-space-3);\n  border-radius: var(--dashboard-radius-md);\n  margin-bottom: var(--dashboard-space-3);\n  border: 1px solid var(--dashboard-border);\n}\n\n.parameter strong {\n  color: var(--dashboard-text-primary);\n  font-weight: 600;\n}\n\n.parameter .type {\n  color: var(--dashboard-text-secondary);\n  font-size: 0.875rem;\n  margin-left: var(--dashboard-space-2);\n}\n\n.parameter .required {\n  background: #fee2e2;\n  color: #dc2626;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin-left: var(--dashboard-space-2);\n}\n\n.parameter p {\n  margin: var(--dashboard-space-2) 0 0 0;\n  color: var(--dashboard-text-secondary);\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n/* Webhook Styles */\n.webhook-features {\n  margin: var(--dashboard-space-8) 0;\n}\n\n.webhook-features h3 {\n  margin: 0 0 var(--dashboard-space-4) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.webhook-features ul {\n  margin: 0;\n  padding-left: var(--dashboard-space-5);\n  color: var(--dashboard-text-secondary);\n}\n\n.webhook-features li {\n  margin-bottom: var(--dashboard-space-2);\n  line-height: 1.5;\n}\n\n.webhook-setup {\n  margin: var(--dashboard-space-8) 0;\n}\n\n.webhook-setup h3 {\n  margin: 0 0 var(--dashboard-space-6) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.setup-step {\n  display: flex;\n  gap: var(--dashboard-space-4);\n  margin-bottom: var(--dashboard-space-6);\n  padding: var(--dashboard-space-6);\n  background: var(--dashboard-bg-secondary);\n  border-radius: var(--dashboard-radius-lg);\n  border: 1px solid var(--dashboard-border);\n}\n\n.step-number {\n  width: 32px;\n  height: 32px;\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.step-content {\n  flex: 1;\n}\n\n.step-content h4 {\n  margin: 0 0 var(--dashboard-space-2) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.step-content p {\n  margin: 0 0 var(--dashboard-space-4) 0;\n  color: var(--dashboard-text-secondary);\n  line-height: 1.5;\n}\n\n/* Events */\n.webhook-events {\n  margin: var(--dashboard-space-8) 0;\n}\n\n.webhook-events h3 {\n  margin: 0 0 var(--dashboard-space-6) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.event-item {\n  background: var(--dashboard-bg-secondary);\n  padding: var(--dashboard-space-6);\n  border-radius: var(--dashboard-radius-lg);\n  border: 1px solid var(--dashboard-border);\n  margin-bottom: var(--dashboard-space-4);\n}\n\n.event-item h4 {\n  margin: 0 0 var(--dashboard-space-2) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.event-item p {\n  margin: 0 0 var(--dashboard-space-4) 0;\n  color: var(--dashboard-text-secondary);\n  line-height: 1.5;\n}\n\n/* Auto Reply */\n.auto-reply-section {\n  margin: var(--dashboard-space-8) 0;\n  background: var(--dashboard-bg-secondary);\n  padding: var(--dashboard-space-6);\n  border-radius: var(--dashboard-radius-lg);\n  border: 1px solid var(--dashboard-border);\n}\n\n.auto-reply-section h3 {\n  margin: 0 0 var(--dashboard-space-4) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.auto-reply-section p {\n  margin: 0 0 var(--dashboard-space-4) 0;\n  color: var(--dashboard-text-secondary);\n  line-height: 1.5;\n}\n\n/* Examples */\n.examples-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));\n  gap: var(--dashboard-space-6);\n  margin: var(--dashboard-space-8) 0;\n}\n\n.example-card {\n  background: var(--dashboard-bg-secondary);\n  border-radius: var(--dashboard-radius-lg);\n  border: 1px solid var(--dashboard-border);\n  overflow: hidden;\n}\n\n.example-card h3 {\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  color: white;\n  margin: 0;\n  padding: var(--dashboard-space-4) var(--dashboard-space-6);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.example-card .code-block {\n  margin: 0;\n  border-radius: 0;\n  border: none;\n}\n\n/* Error Codes */\n.error-codes {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dashboard-space-6);\n}\n\n.error-category {\n  background: var(--dashboard-bg-secondary);\n  border-radius: var(--dashboard-radius-lg);\n  border: 1px solid var(--dashboard-border);\n  overflow: hidden;\n}\n\n.error-category h3 {\n  background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);\n  color: white;\n  margin: 0;\n  padding: var(--dashboard-space-4) var(--dashboard-space-6);\n  font-size: 1.125rem;\n  font-weight: 600;\n}\n\n.error-list {\n  padding: var(--dashboard-space-4);\n}\n\n.error-item {\n  display: flex;\n  gap: var(--dashboard-space-4);\n  padding: var(--dashboard-space-4);\n  background: var(--dashboard-card-bg);\n  border-radius: var(--dashboard-radius-md);\n  border: 1px solid var(--dashboard-border);\n  margin-bottom: var(--dashboard-space-3);\n}\n\n.error-code {\n  background: #fee2e2;\n  color: #dc2626;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 0.875rem;\n  min-width: 50px;\n  text-align: center;\n}\n\n.error-details strong {\n  color: var(--dashboard-text-primary);\n  font-weight: 600;\n  display: block;\n  margin-bottom: var(--dashboard-space-1);\n}\n\n.error-details p {\n  margin: 0;\n  color: var(--dashboard-text-secondary);\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.error-handling {\n  margin: var(--dashboard-space-8) 0;\n  background: var(--dashboard-bg-secondary);\n  padding: var(--dashboard-space-6);\n  border-radius: var(--dashboard-radius-lg);\n  border: 1px solid var(--dashboard-border);\n}\n\n.error-handling h3 {\n  margin: 0 0 var(--dashboard-space-4) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .doc-container {\n    flex-direction: column;\n    padding: var(--dashboard-space-4);\n    gap: var(--dashboard-space-4);\n  }\n  \n  .doc-sidebar {\n    width: 100%;\n    position: static;\n    max-height: none;\n  }\n  \n  .doc-content {\n    max-height: 70vh;\n  }\n  \n  .features-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .examples-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .role-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .endpoint-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--dashboard-space-2);\n  }\n  \n  .setup-step {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .error-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
